import { render, staticRenderFns } from "./guide-status-videos.vue?vue&type=template&id=38d9e8e7"
import script from "./guide-status-videos.vue?vue&type=script&lang=js"
export * from "./guide-status-videos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports